<mat-card-header>
    <mat-card-title>出力条件</mat-card-title>
</mat-card-header>
<div formGroupName="referenceTableForm">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <div
            class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center tw-grow tw-shrink tw-basis-full tw-max-w-[80%]">
            <mat-form-field appearance="outline"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-md:max-w-[full]">
                <mat-label>対象年月</mat-label>
                <input matInput readonly="true" id="chargeCalcYm" class="font-color-display-only"
                    [value]="referenceTableForm.get('chargeCalcYm').value | dateYmStringSg" [disabled]="true">
            </mat-form-field>
            <!-- 使用量上限 -->
            <mat-form-field appearance="outline"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%] tw-md:max-w-[full]">
                <mat-label>出力上限</mat-label>
                <input matInput formControlName="empamtUpperlimit" autocomplete="off" required=""
                    style="text-align: right;" [maxlength]="3" />
                <span matSuffix class="tw-ml-[5px] font-color-display-only">㎥未満</span>
            </mat-form-field>
            <!-- 使用量ステップ値 -->
            <mat-form-field appearance="outline"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-md:max-w-[full]">
                <mat-label>出力間隔</mat-label>
                <mat-select formControlName="referencetableOutputintervalCode" required="">
                    <mat-option *ngFor="let value of referenceTableList" [value]="value.value">
                        {{value.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!-- 早見表出力ボタン -->
        <div
            class="tw-flex tw-flex-row tw-box-border tw-justify-end tw-items-center tw-content-center tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions class="btn_area_right">
                    <button type="submit" mat-raised-button color="primary" class="btn" (click)="onClickOutput()"
                        [disabled]="parentForm.invalid">出力</button>
                </mat-card-actions>
            </div>
        </div>
    </div>